import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'state/types';
import styled from 'styled-components';
import { Question, QuizAnswer } from 'types/quiz';
import ContinueButton from './QuizContinueButton';
import Text from 'components/Text';
import { mobile, tablet } from 'styles/breakpoints';
import { useQuizAnswers } from 'utils/hooks';
import { DynamicImage } from 'components';

interface PreviousMultipleProps {
  question: Question;
  onContinue: () => void;
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  margin-top: 1.5rem;
  @media ${tablet} {
    padding-bottom: 7.5rem;
  }
`;

const Title = styled(Text)`
  font-weight: 700;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.dark100};
  text-align: center;
  line-height: 1.625rem;
  max-width: 21.4375rem;
  margin-bottom: 3rem;

  @media ${tablet} {
    margin-bottom: 1.5rem;
  }
`;

const StyledDynamicImage = styled(DynamicImage)<{
  imageHeightDesktop: string;
  imageHeightTablet: string;
  imageHeightMobile: string;
}>`
  height: ${({ imageHeightDesktop }) => imageHeightDesktop};

  @media ${tablet} {
    height: ${({ imageHeightTablet }) => imageHeightTablet};
  }

  @media ${mobile} {
    height: auto;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  gap: 0.75rem;
`;

const PreviousMultiple: FC<PreviousMultipleProps> = ({
  question,
  onContinue,
}) => {
  const { answers } = useQuizAnswers();

  const previousAnswer = answers[question.key as keyof typeof answers]
    .toString()
    .split('|');
  return (
    <Container>
      <Title>{question.title}</Title>
      <ImageContainer>
        {previousAnswer.map((answer: string) => {
          const matchingQuestion = question.options?.find(
            option => answer === option.value,
          );
          if (matchingQuestion && matchingQuestion.image) {
            return (
              <StyledDynamicImage
                key={matchingQuestion.value}
                src={matchingQuestion.image}
                alt={matchingQuestion.value}
                imageHeightDesktop={question.imageHeightDesktop}
                imageHeightTablet={question.imageHeightTablet}
                imageHeightMobile={question.imageHeightMobile}
              />
            );
          }
        })}
      </ImageContainer>
      <ContinueButton title={question.nextBtnTitle} onClick={onContinue} />
    </Container>
  );
};

export default PreviousMultiple;
